import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { BackOffServiceService } from '../services/back-off-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { isUndefined } from 'util';

@Component({
  selector: 'app-logs-card',
  templateUrl: './logs-card.component.html',
  styleUrls: ['./logs-card.component.css']
})
export class LogsCardComponent implements OnInit {

  isDashboard: boolean = true;
  isFoodLog: boolean = false;
  isActivityLog: boolean = false;
  isWeightLog: boolean = false;
  isHealthLog: boolean = false;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  param1: string;
  isDoc = false;
  isCoach = false;
  isLoggin = false;
  lifestyleDone = false;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute,
    private _bkoffService: BackOffServiceService,
    private router: Router,
    private modalService: NgbModal,
    private cookie: CookieService
  ) {
    console.log('here in log card constructor');
    this.param1 = this.route.snapshot.params.id;
  //   this.route.queryParams.subscribe(params => {
  //     this.param1 = params.id;
  // });
    console.log('Param' + this.param1);

  }

  ngOnInit() {
    console.log('here in log card init');
    if (!isUndefined(this.param1)) {
      this.cookie.set('userObjectId', this.param1);
      this.cookie.set('isFinishedLogin', 'true');
      this.cookie.set('sessionToken', this.param1);
      this._bkoffService.getisDone().then((res) => {
        this.isDoc = true;
        this.isCoach = true;
        if (this.isDoc === res[1]) {
          this.cookie.set('patientId', 'none');
          this.router.navigateByUrl('/doccard');
        } else if (this.isCoach === res[4]) {
          this.router.navigateByUrl('/coachclasses');
        } else {
          this.router.navigateByUrl('/logs');
        }
      });
  }
  }

  toggleDashboard() {
    console.log('toggling dashboard');
    this.isDashboard = !this.isDashboard;
    console.log(this.isDashboard);
  }

  toggleFoodLog() {
    console.log('toggling food log');
    this.isFoodLog = !this.isFoodLog;
    console.log(this.isFoodLog);
  }

  toggleWeightLog() {
    this.isWeightLog = !this.isWeightLog;
  }

  toggleActivityLog() {
    this.isActivityLog = !this.isActivityLog;
  }

  toggleHealthLog() {
    this.isHealthLog = !this.isHealthLog;
  }

}
